import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField, type TextFieldProps } from '@mui/material';
import { useState } from 'react';

// поле для нового пароля (без автозаполнения). для форм регистрации и сброса пароля
export function NewPasswordField({ value, ...rest }: TextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      fullWidth
      variant="outlined"
      sx={{ borderRadius: 1 }}
      autoComplete="off"
      value={value}
      slotProps={{
        input: {
          sx: { background: 'rgb(232, 240, 254)' },

          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                onMouseUp={(e) => e.preventDefault()}
                edge="end"
                tabIndex={-1}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
        htmlInput: {
          // если использовать type=password, то браузер будет делать автозаполнение
          className: !showPassword ? 'password-mask' : '',
        },
      }}
      {...rest}
    />
  );
}
